import { Card, CardContent, Typography } from "@mui/material";
import Colors from "../../../constants/Colors";
import UnitLabel from "../../helpers/UnitLabel";

interface Props {
  id: string;
  name: string;
  unit: string;
  width?: string | number | null;
  grammage?: string | number | null;
  //color: string;
}

const ProductDetailCard = (props: Props): JSX.Element => {
  const { id, name, unit, width, grammage } = props;
  const hasValue = (value: string | number | null | undefined) =>
    value !== null && value !== undefined && String(value).trim() !== "";
  {
    /*, color*/
  }

  return (
    <Card sx={{ boxShadow: 2 }}>
      <CardContent>
        <Typography
          variant="body2"
          fontWeight={"bold"}
          color={Colors.primary}
          fontSize={16}
          mb={2}
        >
          {id}
        </Typography>
        <Typography
          variant="body2"
          color={"gray"}
          fontSize={11}
          fontWeight={"bold"}
        >
          NOME
        </Typography>
        <Typography variant="body2" mb={1}>
          {name}
        </Typography>

        {/*<Typography
          variant="body2"
          color={"gray"}
          fontSize={11}
          fontWeight={"bold"}
        >
          COR
        </Typography>
        <Typography variant="body2" mb={1}>
          {color}
        </Typography>*/}

        <Typography
          variant="body2"
          color={"gray"}
          fontSize={11}
          fontWeight={"bold"}
        >
          UM
        </Typography>
        <Typography variant="body2" mb={1}>
          <UnitLabel unit={unit} />
        </Typography>

        {hasValue(width) && (
          <>
            <Typography
              variant="body2"
              color={"gray"}
              fontSize={11}
              fontWeight={"bold"}
            >
              LARGURA
            </Typography>
            <Typography variant="body2" mb={1}>
              {width}
            </Typography>
          </>
        )}

        {hasValue(grammage) && (
          <>
            <Typography
              variant="body2"
              color={"gray"}
              fontSize={11}
              fontWeight={"bold"}
            >
              GRAMATURA
            </Typography>
            <Typography variant="body2" mb={1}>
              {grammage}
            </Typography>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default ProductDetailCard;
